/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyChainBulkBillingExcludedPharmaciesTypename = "PharmacyChainBulkBillingExcludedPharmacies" as const;

/**
 *
 * @export
 * @interface PharmacyChainBulkBillingExcludedPharmacies
 */
export interface PharmacyChainBulkBillingExcludedPharmacies {
  /**
   *
   * @type {number}
   * @memberof PharmacyChainBulkBillingExcludedPharmacies
   */
  chainId: number;
  /**
   *
   * @type {Array<number>}
   * @memberof PharmacyChainBulkBillingExcludedPharmacies
   */
  pharmacyIds?: Array<number>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyChainBulkBillingExcludedPharmacies
   */
  readonly __typename?: string;
}

export function PharmacyChainBulkBillingExcludedPharmaciesFromJSON(
  json: any
): PharmacyChainBulkBillingExcludedPharmacies {
  return PharmacyChainBulkBillingExcludedPharmaciesFromJSONTyped(json, false);
}

export function PharmacyChainBulkBillingExcludedPharmaciesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyChainBulkBillingExcludedPharmacies {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyChainBulkBillingExcludedPharmaciesTypename,

    chainId: json["chain_id"],
    pharmacyIds: !exists(json, "pharmacy_ids") ? undefined : json["pharmacy_ids"],
  };
}

export function PharmacyChainBulkBillingExcludedPharmaciesToJSON(
  object?: PharmacyChainBulkBillingExcludedPharmacies | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    chain_id: value.chainId,
    pharmacy_ids: value.pharmacyIds,
  };
}
